import { useMemo } from "react";
import JsonFormsWrapper from "../jsonForms/jsonFormsWrapper/JsonFormsWrapper";
import AddRewards from "./AddRewards";

const listRewardsJson = {
  jsonSchema: {
    type: "object",
    properties: {
      name: {
        type: "string",
      },
      position: {
        type: "integer",
      },
      numberOfWinnersLimit: {
        type: "integer",
      },
      description: {
        type: "string",
      },
    },
    required: ["numberOfWinnersLimit", "position"],
  },
  uiSchema: {
    type: "VerticalLayout",
    elements: [
      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/name",
            component: "textField",
            label: "Reward Group Name",
          },
          {
            type: "Control",
            scope: "#/properties/position",
            component: "textField",
            label: "Position on gift selection page",
          },
        ],
      },
      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/numberOfWinnersLimit",
            component: "textField",
            label: "Max participation",
          },
        ],
      },
      {
        type: "Control",
        scope: "#/properties/description",
        component: "textarea",
        label: "Reward group description",
      },
    ],
  },
};

const chanceRewardsSchema = {
  jsonSchema: {
    type: "object",
    properties: {
      image: {
        type: "string",
      },
      name: {
        type: "string",
      },
      position: {
        type: "integer",
      },
      numberOfWinnersLimit: {
        type: "integer",
      },
      description: {
        type: "string",
      },
      isSpinWheelEnabled: {
        type: "boolean",
        default: false,
      },
    },
    required: ["name", "numberOfWinnersLimit", "description", "position", "image"],
  },
  uiSchema: {
    type: "HorizontalLayout",
    elements: [
      {
        type: "Control",
        scope: "#/properties/image",
        component: "singleImageUpload",
        label: "Reward group image",
        accept: ["image/png", "image/jpg", "image/jpeg"],
        maxWidth: "360",
        maxHeight: "357",
        requiredResolution: true,
      },
      {
        type: "VerticalLayout",
        elements: [
          {
            type: "HorizontalLayout",
            elements: [
              {
                type: "Control",
                scope: "#/properties/name",
                component: "textField",
                label: "Reward Group Name",
              },
              {
                type: "Control",
                scope: "#/properties/position",
                component: "textField",
                label: "Position on gift selection page",
              },
            ],
          },
          {
            type: "HorizontalLayout",
            elements: [
              {
                type: "Control",
                scope: "#/properties/numberOfWinnersLimit",
                component: "textField",
                label: "Max Participation",
              },
              {
                type: "Control",
                scope: "#/properties/isSpinWheelEnabled",
                component: "toggle",
                label: "Enable/Disable Spin the wheel option",
              },
            ],
          },
          {
            type: "Control",
            scope: "#/properties/description",
            component: "textarea",
            label: "Reward group description",
          },
        ],
      },
    ],
  },
};

export const RewardGroupCampaignSetup = ({ value, updateValue, campaignType }) => {
  const listRewardsSchema = useMemo(() => {
    const schema = JSON.parse(JSON.stringify(listRewardsJson));
    if (campaignType === "standard_campaign") {
      schema.uiSchema.elements[1].elements.splice(0, 0, {
        type: "Control",
        scope: "#/properties/numberOfCodeScansRequiredToWin",
        component: "textField",
        label: "Number of code scans required to win*",
      });
      schema.jsonSchema.properties.numberOfCodeScansRequiredToWin = {
        type: "integer",
      };
      schema.jsonSchema.required.push("numberOfCodeScansRequiredToWin");
    }
    return schema;
  }, [campaignType]);
  return (
    <>
      <div className="mt-3 w-100">
        <JsonFormsWrapper
          jsonschema={
            value?.type === "LIST"
              ? listRewardsSchema.jsonSchema
              : chanceRewardsSchema.jsonSchema
          }
          uischema={
            value?.type === "LIST"
              ? listRewardsSchema.uiSchema
              : chanceRewardsSchema.uiSchema
          }
          data={value}
          onChange={updateValue}
        />
      </div>
      <AddRewards
        value={value?.rewardGroupRewards || []}
        updateValue={(val, remove, rewardItem) => {
          updateValue({ ...value, rewardGroupRewards: val }, remove, rewardItem);
        }}
        type={value?.type}
        activeStartDate={value?.activeStartDate}
        isSpinWheelEnabled={value?.isSpinWheelEnabled || false}
      />
    </>
  );
};
